import { render, staticRenderFns } from "./TeacherIndex.vue?vue&type=template&id=05c253a7&"
import script from "./TeacherIndex.vue?vue&type=script&lang=js&"
export * from "./TeacherIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports